module.exports = {
  login: {
    url: '/vis_user/login'
  }
};
